<template>
	<div class="firebase-block-warning">
        <Transition name="fade" mode="in-out">
            <block-warning v-if="!loading">
                <template #message>
                    <div v-html="formatedMessage" @click="handleClick"></div>
                </template>
            </block-warning>
        </Transition>
        <f7-skeleton-block v-if="loading" class="skeleton-effect-wave" />
	</div>
</template>

<script setup lang="ts">
import BlockWarning from "@components/atomic/block-warning/BlockWarning.vue";
import { computed } from "vue";
import { getDevice } from "framework7/shared/get-device";
import LangService from "@/services/LangService";
import ModelWarningBlockNotification from "@models/v2/firebase/warning-blocks/ModelWarningBlockNotification";

interface IProps {
	message: ModelWarningBlockNotification;
	loading?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
	loading: false,
});

const openAlertToTelegram = (url: string) => {
	if (getDevice().cordova) {
		// @ts-ignore
		window.cordova.InAppBrowser.open(url, "_system");
	} else {
		try {
			if (getDevice().ios) {
				// @ts-ignore
				window.webkit.messageHandlers.iosListener.postMessage(
					JSON.stringify({ deeplink: url })
				);
			} else if (getDevice().android) {
				// @ts-ignore
				window.webInterface.onMessage(JSON.stringify({ deeplink: url }));
			} else {
				window.open(url, "_blank");
			}
		} catch {
			window.open(url, "_blank");
		}
	}
};

const wrapWordsWithLinks = (text: string): string => {
	return text.replace(/(\S+?)#(https?:\/\/\S+)/g, (_, word, url) => {
		return `<a href="${url}" data-support-link="true" data-url="${url}">${word}</a>`;
	});
};

const lang = computed(() => LangService.getInstance().get() as 'ru' | 'en');

const formatedMessage = computed(() => wrapWordsWithLinks(lang.value === 'ru' ? props.message.messageRu : props.message.messageEn));

const handleClick = (event: MouseEvent) => {
	const target = event.target as HTMLElement;
	if (target.tagName === "A" && target.dataset.supportLink === "true") {
		event.preventDefault();
		const url = target.dataset.url;
		if (url) {
			openAlertToTelegram(url);
		}
	}
};
</script>

<style lang="scss" scoped>
  .firebase-block-warning {
    flex-shrink: 0;
    --skeleton-color: #DBDDE4;

    .skeleton-block {
      height: 56px;
      width: 100%;
      border-radius: 8px;
    }

    .bounce-enter-active {
      animation: bounce-in 0.5s;
    }
    .bounce-leave-active {
      animation: bounce-in 0.5s reverse;
    }

    @keyframes bounce-in {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.1);
      }
      100% {
        transform: scale(1);
      }
    }
  }
</style>
